// Navigation items for LInvoice project

import {
  ClientsIcon,
  MessagesIcon,
  ReportsIcon,
  StoresIcon,
  TaxSettingsIcon,
} from '../../components/MainNavigation/icons'
import DocumentIcon from '../../components/MainNavigation/icons/DocumentIcon'
import LookUpIcon from '../../components/MainNavigation/icons/LookUp'
import { getCombinedSettingsMessageCount } from 'utils/settingsNavBadgeCount'

/**
 * Get navigation items for LInvoice project
 * @param {Object} context - Context object with location, t, newMessagesCount
 * @returns {Array} Array of navigation items
 */
export const getLInvoiceNavigationItems = (context) => {
  const { location, t, newMessagesCount = {} } = context

  const printMessagesCount = (count) => {
    if (count) {
      return count
    }
    return null
  }

  return [
    {
      url: '/lookUp',
      label: t('einvoice:sidebar.lookUp'),
      icon: () => <LookUpIcon selected={location.pathname.startsWith('/lookUp')} />,
      selected: location.pathname.startsWith('/lookUp'),
      isTaxAgentMainVisible: true,
    },
    {
      url: '/documents',
      label: t('einvoice:sidebar.documents'),
      icon: () => <DocumentIcon selected={location.pathname.startsWith('/documents')} />,
      badge: printMessagesCount(newMessagesCount.documents),
      selected: location.pathname.startsWith('/documents'),
      isTaxAgentMainVisible: true,
    },
    {
      url: '/e-documents',
      label: t('einvoice:sidebar.edocuments'),
      icon: () => <DocumentIcon selected={location.pathname.startsWith('/e-documents')} />,
      badge: printMessagesCount(newMessagesCount.e_documents),
      selected: location.pathname.startsWith('/e-documents'),
      isTaxAgentMainVisible: true,
    },
    {
      url: '/customers',
      label: t('einvoice:sidebar.customers'),
      icon: () => <ClientsIcon selected={location.pathname.startsWith('/customers')} />,
      badge: printMessagesCount(newMessagesCount.customers),
      selected: location.pathname.startsWith('/customers'),
      isTaxAgentMainVisible: true,
    },
    {
      url: '/messages',
      label: t('menu.messages'),
      icon: () => <MessagesIcon selected={location.pathname.startsWith('/messages')} />,
      badge: printMessagesCount(newMessagesCount.messages),
      selected: location.pathname.startsWith('/messages'),
      isTaxAgentMainVisible: true,
    },
    {
      url: '/reports',
      label: t('einvoice:sidebar.reports'),
      icon: () => <ReportsIcon selected={location.pathname.startsWith('/reports')} />,
      badge: printMessagesCount(newMessagesCount['doc-reports']),
      selected: location.pathname.startsWith('/reports'),
      isTaxAgentMainVisible: true,
    },
    {
      url: '/settings',
      label: t('einvoice:sidebar.settings'),
      icon: () => <TaxSettingsIcon selected={location.pathname.startsWith('/settings')} />,
      badge: printMessagesCount(
        getCombinedSettingsMessageCount(newMessagesCount, 'invoice_settings')
      ),
      selected: location.pathname.startsWith('/settings'),
      isTaxAgentMainVisible: true,
    },
    {
      url: '/integrations',
      label: t('einvoice:sidebar.integrations'),
      icon: () => <StoresIcon selected={location.pathname.startsWith('/integrations')} />,
      badge: printMessagesCount(newMessagesCount.sites),
      selected: location.pathname.startsWith('/integrations'),
      isTaxAgentMainVisible: false,
    },
  ]
}
